export const getFileNameFromUrl = (url: string): string => {
  const { pathname } = new URL(url);
  // eslint-disable-next-line functional/immutable-data
  return pathname.split('/').pop();
};
